export enum PAYMENT_METHOD_TYPE {
    CASH = 'cash',
    CARD = 'card',
    BANK = 'bank',
}

export type CustomerPaymentMethod = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    valid_from: string | null;
    valid_to: string | null;
    type: PAYMENT_METHOD_TYPE;
    is_primary: boolean | null;
    token: string | null;
    details: unknown | null;
    customer: {
        name: string;
        id: string;
    };
};
